import { useDispatch, useSelector } from "react-redux";
import { setNextState } from "../../store/reducers/progressionReducer";
import React, { useEffect } from "react";
import styles from "./Controls.module.css";
import { gsap } from "gsap"
import { pushEvent } from "../../gtm";

export default function Controls() {
    const dispatch = useDispatch();
    const nextState = useSelector((state) => state.progression.nextState);
    const currentState = useSelector((state) => state.progression.currentState);
    const currentModule = useSelector((state) => state.progression.currentModule);
    const activeCamera = useSelector((state) => state.progression.activeCamera);


    useEffect(() => {
        const isMobile = window.innerWidth <= 768;
        if (activeCamera == "MainCamera") {
            if (isMobile && currentModule !== "none") {
                gsap.to(`.${styles.controls}`, {
                    opacity: 0,
                    duration: 1,
                    ease: "power2.out",
                })
            }
            else {
                gsap.to(`.${styles.controls}`, {
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                })
            }
        }
    }, [currentModule, activeCamera])

    const handleNavClick = (state, section) => {
        dispatch(setNextState(state));
        pushEvent('main_nav', { section });
    };

    // Utiliser currentState si nextState est "none", sinon nextState
    const activeState = nextState !== "none" ? nextState : currentState;

    return (
        <div className={styles.controls}>

            <nav className={styles.interestPoints}>
                <button onClick={() => handleNavClick("TechnologyHub", "Technology Hub")} className={activeState === "TechnologyHub" ? styles.selected : ""}>
                    Technology Hub
                </button>
                <button onClick={() => handleNavClick("OptometryLab", "Optometry Lab")} className={activeState === "OptometryLab" ? styles.selected : ""}>
                    Optometry Lab
                </button>

                <button onClick={() => handleNavClick("ServiceCenter", "Services Center")} className={activeState === "ServiceCenter" ? styles.selected : ""}>
                    Services Center
                </button>


                <button onClick={() => handleNavClick("LdCenter", "L&D Center")} className={activeState === "LdCenter" ? styles.selected : ""}>
                    L&D Center
                </button>
            </nav>

        </div>
    );
}
